import React, { useContext } from "react";
import { Redirect } from "react-router-dom";
import Layout from "../components/Layout/Layout";
import ProductNavigationV3 from "../components/ProductNavigationV3/ProductNavigationV3";
import { ProductSelectSettingsContainer } from "../containers/ProductsSelectSettingContainer/ProductsSelectSettingContainer";
import { QuoteGroupContext } from "../providers/RootContextProvider";

const RouteRedirects: React.FC = () => {
    const { selectors } = useContext(QuoteGroupContext);

    const hasAnySettings = selectors.getAllSettings().some((s) => s.caseId > 0);
    if (hasAnySettings)
        return <Redirect to={"results"} />;

    return (
        <Layout
            hideMenu={!selectors.hasCreatedQuote()}
            progressBarCurrentStage={"build"}>
            <div className="layout-multi-products-nav-V3">
                <ProductSelectSettingsContainer heading="Select the type of insurance you'd like to compare">
                    <ProductNavigationV3 />
                </ProductSelectSettingsContainer>
            </div>
        </Layout>
    );
};

export default RouteRedirects;
